
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as clientssoMFDfJyZ6Meta } from "/codebuild/output/src2808178616/src/web-front-end/pages/app/clients.vue?macro=true";
import { default as indexD011nipwP1Meta } from "/codebuild/output/src2808178616/src/web-front-end/pages/app/index.vue?macro=true";
import { default as pricinghxdfYg6rlJMeta } from "/codebuild/output/src2808178616/src/web-front-end/pages/app/pricing.vue?macro=true";
import { default as _91id_93fT6DERGRqMMeta } from "/codebuild/output/src2808178616/src/web-front-end/pages/app/report/[id].vue?macro=true";
import { default as reportswjx43DuwIlMeta } from "/codebuild/output/src2808178616/src/web-front-end/pages/app/reports.vue?macro=true";
import { default as users51IoFPYna9Meta } from "/codebuild/output/src2808178616/src/web-front-end/pages/app/users.vue?macro=true";
import { default as experimentCsDlomzKgpMeta } from "/codebuild/output/src2808178616/src/web-front-end/pages/experiment.vue?macro=true";
import { default as indexDXTcmN7wm5Meta } from "/codebuild/output/src2808178616/src/web-front-end/pages/index.vue?macro=true";
import { default as legalGMA2yyHXYVMeta } from "/codebuild/output/src2808178616/src/web-front-end/pages/legal.vue?macro=true";
import { default as reset_45passwordDP3cckBWEYMeta } from "/codebuild/output/src2808178616/src/web-front-end/pages/reset-password.vue?macro=true";
import { default as sign_45iniH4U5xx8BrMeta } from "/codebuild/output/src2808178616/src/web-front-end/pages/sign-in.vue?macro=true";
import { default as sign_45uphVmvsFDUazMeta } from "/codebuild/output/src2808178616/src/web-front-end/pages/sign-up.vue?macro=true";
export default [
  {
    name: "app-clients",
    path: "/app/clients",
    meta: clientssoMFDfJyZ6Meta || {},
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/app/clients.vue")
  },
  {
    name: "app",
    path: "/app",
    meta: indexD011nipwP1Meta || {},
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/app/index.vue")
  },
  {
    name: "app-pricing",
    path: "/app/pricing",
    meta: pricinghxdfYg6rlJMeta || {},
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/app/pricing.vue")
  },
  {
    name: "app-report-id",
    path: "/app/report/:id()",
    meta: _91id_93fT6DERGRqMMeta || {},
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/app/report/[id].vue")
  },
  {
    name: "app-reports",
    path: "/app/reports",
    meta: reportswjx43DuwIlMeta || {},
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/app/reports.vue")
  },
  {
    name: "app-users",
    path: "/app/users",
    meta: users51IoFPYna9Meta || {},
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/app/users.vue")
  },
  {
    name: "experiment",
    path: "/experiment",
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/experiment.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/legal.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/reset-password.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/sign-in.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/codebuild/output/src2808178616/src/web-front-end/pages/sign-up.vue")
  }
]